import http from "../http-common";

class FlightTypeService {
  getFlightTypeDescription(token) {
    return http.get<any[]>("/api/FlightTypeInfo",{
        headers: {
            Authorization: `Bearer ${token}`
    }
    });
  }
}

const flightTypeService = new FlightTypeService();
export default flightTypeService;
